
export function TextToPemConverter(textInput, originalname) {
    const pemContent = `----BEGIN CERTIFICATE----\n${textInput}\n----END CERTIFICATE----`
    const blob = new File([pemContent], originalname, {type: 'application/octet-stream'});
    return blob;
}
